module.exports = __webpack_public_path__ + "static/radoslav.0464aa0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/graphics/contributors/radoslav.jpg
// module id = ./src/assets/graphics/contributors/radoslav.jpg
// module chunks = 0 1